import { render, staticRenderFns } from "./ProjectUserEdit.vue?vue&type=template&id=a8e17964&scoped=true&"
import script from "./ProjectUserEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectUserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e17964",
  null
  
)

export default component.exports